/* eslint-disable */
import * as React from "react";
import { useLocation, useParams } from "react-router";
import { useNavigate } from "react-router-dom";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import Swal from "sweetalert2/dist/sweetalert2.js";
import dayjs from "dayjs";
import RegistrationForm from "../components/ReEvaluate/RegistrationForm";
// import RequiredDocument from "../components/ReEvaluate/RequiredDocument";
import ApprovalStatus from "../components/ReEvaluate/ApprovalStatus";
import { RequestFormAPI, SharePointFolder } from "../services/apigateway";
import helper from "../services/helper";
import { useEffect } from "react";
import DescriptionIcon from "@mui/icons-material/Description";
import { API_FIELD_NAME_SF, REQUEST_HEADER } from "../utils/sfMappingFields";
import ModalRegistrationForm from "../components/ReEvaluate/Modal/ModalRegistrationForm";
import "../styles/ReEvaluate.css";
import RegistrationFormView from "../components/ReEvaluate/RegistrationFormView";

// สถานะ (ค่าดิบจาก Salesforce) ที่ไม่ให้กด Submit
const DISABLED_SUBMIT_STATUSES = [
  "approval in progress",
  "approved",
  "rejected",
  "canceled",
];

// สถานะฝั่งลูกค้าที่ map มาจากสถานะด้านบน (ใช้ตอนไม่มีค่า Status ดิบ)
const DISABLED_SUBMIT_STATUSES_CUSTOMER = [
  "in approval process",
  "completed",
  "end process",
];

export default function ReEvaluateScreen() {
  const { id, tab } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const userInfoTest = helper.Auth.getTokenData();
  const [lastModifiedDate, setLastModifiedDate] = React.useState();
  const [requestNumber, setRequestNumber] = React.useState();
  const [activeTab, setActiveTab] = React.useState("RegistrationForm");
  const [dataSaving, setDataSaving] = React.useState(false);
  const [dataLoading, setDataLoading] = React.useState(false);
  const [uploadFileOther, setUploadFileOther] = React.useState([]);
  const [pathsSharePoint, setPathsSharePoint] = React.useState([]);
  const [company, setCompany] = React.useState("");
  const [companyName, setCompanyName] = React.useState("");
  const [isEditedForm, setIsEditedForm] = React.useState(false);
  const [openModal, setOpenModal] = React.useState(false);
  const [objRegistrationForm, setObjRegistrationForm] = React.useState({
    RequestFormHeaderId: "",
    RequestFormItemId: "",
    CustomerId: "",
    CompanyNameLocal: "",
    CompanyNameEN: "",
    CompanyNameFormer: "",
    CompanyNameLanguage: "",
    CompanyNameAlias: "",
    CustomerType: "",
    SupplierType: "",
    BusinessType: "",
    BusinessTypeOthers: "",
    LegalEntityType: "",
    LegalEntityTypeOthers: "",
    IncorporationDate: "",
    TAXNumber: "",
    Website: "",
    CEOFirstName: "",
    CEOLastName: "",
    Shareholders: [
      {
        Id: "",
        Name: "",
        PercentOfShareholder: 0,
        RequestFormHeaderId: "",
      },
    ],
    // address local
    HouseNo: "",
    Building: "",
    Room: "",
    Floor: "",
    Street: "",
    District: "",
    SubDistrict: "",
    Disctrict: "",
    City: "",
    PostalCode: "",
    // address englishs
    HouseNoEN: "",
    BuildingEN: "",
    RoomEN: "",
    FloorEN: "",
    StreetEN: "",
    DistrictEN: "",
    SubDistrictEN: "",
    CityEN: "",
    PostalCodeEN: "",
    // country
    Country: "",
    LocationURL: "",
    Latitude: "",
    Longitude: "",
    MailingIsSameAsRegistered: false,
    MailingIsSameAsRegisteredEN: false,
    MailingHouseNo: "",
    MailingBuilding: "",
    MailingRoom: "",
    MailingFloor: "",
    MailingStreet: "",
    MailingSubDistrict: "",
    MailingDistrict: "",
    MailingCity: "",
    MailingCountry: "",
    MailingPostalCode: "",
    ContactId: "",
    ContactSalutation: "",
    ContactNickName: "",
    ContactFirstName: "",
    ContactLastName: "",
    ContactPosition: "",
    ContactEmail: "",
    ContactMobileCountryCode: "",
    ContactMobileNumber: "",
    ContactPhoneCountryCode: "",
    ContactPhoneNumber: "",
    ContactFaxCountryCode: "",
    ContactFaxNumber: "",
    InterestedPetroleumAsCustomer: false,
    InterestedPetrochemicalAsCustomer: false,
    InterestedLubeBaseAsCustomer: false,
    InterestedLABIXAsCustomer: false,
    InterestedCrudeAsCustomer: false,
    InterestedLubeBaseAsCustomerDesc: "",
    InterestedLABIXAsCustomerDesc: "",
    InterestedCrudeAsSupplier: false,
    InterestedB100EthanolAsSupplier: false,
    InterestedPetroleumAndComponentAsSupplier: false,
    InterestedPetroleumAndComponentAsSupplierDesc: "",
    InterestedLongResidueAsSupplier: false,
    InterestedNormalParaffinAsSupplier: false,
    InterestedOtherAsCustomer: false,
    InterestedOtherAsCustomerDesc: "",
    InterestedOtherAsSupplier: false,
    InterestedOtherAsSupplierDesc: "",
    MinistryOfEnergyRegistrationNo: "",
    YearsOfExperience: "",
    EstimatedMonthlyPurchaseQuantity: 0,
    EstimatedMonthlyPurchaseUnit: "",
    StartTradingDate: dayjs(),
    DestinationCountries: [
      {
        Id: "",
        Country: "",
        LocationType: "",
      },
    ],
    PurchaseProductFromCompany: "",
    SupplyProductToCompany: "",
    PaymentOverTheAmountOfUSD: "",
    ReasonOfPaymentOverTheAmountOfUSD: "",
    FailedSupplyAgreement: "",
    ReasonOfFailedSupplyAgreement: "",
    HaveTagetsInSanction: "",
    ReasonOfHaveTagetsInSanction: "",
    ViolatingAntiMoneyLaunderingLaws: "",
    ReasonOfViolatingAntiMoneyLaunderingLaws: "",
    CustomersFacilityTankAndStorage: "",
    // OwnStorageAsCustomer: false,
    // RentStorageMoreThanOneYearAsCustomer: false,
    // RentStorageLessThanOneYearAsCustomer: false,
    // NoStorageAsCustomer: false,
    CustomersFacilityTransportation: "",
    SuppliersFacilityTankAndStorage: "",
    SuppliersFacilityTransportation: "",
    EnvironmentPolicy: "",
    OccupationalHealthAndSafetyPolicy: "",
    CorporateGovernancePolicy: "",
    HumanRightsPolicy: "",
    SocialResponsibilityPolicy: "",
    CompanyLatestCreditRating: "",
  });
  const [registrationNumber, setRegistrationNumber] = React.useState("");
  const [originalFormData, setOriginalFormData] = React.useState(null);

  // Fetch master data
  const masterDataRegistrationForm = React.useCallback(async (id) => {
    try {
      setDataLoading(true);
      const data = await RequestFormAPI.getById(id);
      setObjRegistrationForm(data);
      setOriginalFormData(data);

      if (data?.RequestItems?.length > 0) {
        setLastModifiedDate(
          dayjs(data.RequestItems[0].LastModifiedDate).format(
            "DD/MM/YYYY HH:mm"
          )
        );
        setRequestNumber(data.RequestItems[0].Name);
      }
    } catch (error) {
      console.error("Error fetching registration form:", error);
    } finally {
      setDataLoading(false);
    }
  }, []);

  useEffect(() => {
    if (id) masterDataRegistrationForm(id);
  }, [id, masterDataRegistrationForm]);

  // Fetch SharePoint paths
  useEffect(() => {
    const fetchSharePointPaths = async () => {
      try {
        const userInfo = helper.Auth.getTokenData();
        if (!userInfo?.accounts?.[0]) return;

        const response = await SharePointFolder.getPathByAccount(
          userInfo.accounts[0].Id
        );

        // find customer
        let customerId = location.state.customerId || "";
        let findCustomerAcc =
          (customerId &&
            userInfo.accounts.find((cus) => cus.Id === customerId)) ||
          userInfo.accounts[0];

        setCompany(findCustomerAcc);
        setCompanyName(findCustomerAcc.Name);
        const filesSharePoint = response.responseData || [];

        const fileNames = [
          "Account_Common_CTR_Financial",
          "Account_Common_CTR_COI",
          "Account_Common_CTR_MOA",
          "Account_Common_CTR_List_Sharehold",
          "Account_Common_CTR_VAT_Reg",
          "Account_Common_CTR_Reg_by_MoE",
          "Account_Common_CTR_Others",
        ];

        const mappedPaths = fileNames.reduce((acc, name) => {
          const file = filesSharePoint.find((item) => item.Name === name);
          acc[name] = file?.Path || "";
          return acc;
        }, {});

        setPathsSharePoint(mappedPaths);
      } catch (error) {
        console.error("Error fetching SharePoint paths:", error);
      }
    };

    fetchSharePointPaths();
  }, []);

  const uploadFile = async (folder, file) => {
    try {
      const uploadResponse = await SharePointFolder.uploadFile(folder, [file]);
      console.log("Upload response:", uploadResponse);

      // Check if upload failed
      if (!uploadResponse || uploadResponse.error || uploadResponse.message === 'error' || uploadResponse.message === 'Upload failed') {
        Swal.fire({
          title: "Upload Failed",
          text: "Upload failed. Please try again or contact your administrator.",
          icon: "error",
          position: "center",
          showConfirmButton: true,
        }).then((res) => {
          if (res.isConfirmed) {
            window.location.reload();
          }
        });
        return false;
      }
      return true;
    } catch (error) {
      console.error("Error while uploading:", error);
      if (error.response) {
        console.error("Response:", error.response);
      }
      Swal.fire({
        title: "Upload Failed",
        text: "Upload failed. Please try again or contact your administrator.",
        icon: "error",
        position: "center",
        showConfirmButton: true,
      }).then((res) => {
        if (res.isConfirmed) {
          window.location.reload();
        }
      });
      return false;
    }
  };

  const updateFiles = async () => {
    try {
      const filesMap = {
        FinancialFirst: pathsSharePoint.Account_Common_CTR_Financial,
        FinancialSecond: pathsSharePoint.Account_Common_CTR_Financial,
        FinancialThird: pathsSharePoint.Account_Common_CTR_Financial,
        FileCOI: pathsSharePoint.Account_Common_CTR_COI,
        FileMOA: pathsSharePoint.Account_Common_CTR_MOA,
        FileVAT: pathsSharePoint.Account_Common_CTR_VAT_Reg,
        FileShareholder: pathsSharePoint.Account_Common_CTR_List_Sharehold,
        FileMoE: pathsSharePoint.Account_Common_CTR_Reg_by_MoE,
        FileOther: pathsSharePoint.Account_Common_CTR_Others,
      };

      const files = {};
      let allFilesSelected = true;

      for (const [id, folder] of Object.entries(filesMap)) {
        const fileInput = document.getElementById(id);
        if (fileInput && fileInput.files.length > 0) {
          files[id] = fileInput.files;
        } else {
          allFilesSelected = false;
        }
      }

      if (!allFilesSelected) {
        console.error("Please select all required files.");
        return;
      }

      // Uploading files
      for (const [id, fileList] of Object.entries(files)) {
        const folder = filesMap[id];
        if (id === "FileOther") {
          for (const file of fileList) {
            const uploadResult = await uploadFile(folder, file);

            // ถ้า upload ไม่สำเร็จ ให้หยุดทันที
            if (uploadResult === false) {
              throw new Error("Upload failed");
            }
          }
        } else {
          const uploadResult = await uploadFile(folder, fileList[0]);

          // ถ้า upload ไม่สำเร็จ ให้หยุดทันที
          if (uploadResult === false) {
            throw new Error("Upload failed");
          }
        }
      }

      // Resetting input values after successful upload
      for (const id in files) {
        document.getElementById(id).value = "";
      }
    } catch (error) {
      console.error("Error in handling file upload:", error);
      throw error; // Re-throw เพื่อให้ caller รู้ว่ามี error
    }
  };

  const updateRequestFormByIds = async (data) => {
    let dataUpdate = data;
    const changedFields = await detectChanges(originalFormData, dataUpdate);
    dataUpdate.InternalEditField__c = JSON.stringify(changedFields) || [];

    Swal.fire({
      title: "Are you sure you want to save?",
      icon: "question",
      position: "center",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Yes",
      cancelButtonColor: "red",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setDataSaving(true);
          let resV = await RequestFormAPI.updateRequestForm(dataUpdate);
          setRegistrationNumber(resV.RegistrationNumber);
          setOpenModal(true);
          setObjRegistrationForm(resV);
          setIsEditedForm((prev) => !prev); // Toggle state directly
          setDataSaving(false);
          // await updateFiles();

          Swal.fire({
            title: "Saved!",
            icon: "success",
            showConfirmButton: false,
            timer: 1200,
          });

          // window.scrollTo({ top: 0, behavior: "smooth" });
        } catch (error) {
          console.error("Error updating request form:", error);
          setDataSaving(false);
          Swal.fire({
            title: "Failed to Save",
            icon: "error",
            showConfirmButton: true,
          });
        }
      }
    });
  };

  function detectChanges(original, updated) {
    let getInterFieldsOld = [];

    // Validate before parsing
    try {
      let jsonString = objRegistrationForm.InternalEditField__c;
      if (typeof jsonString === "string" && jsonString.trim() !== "") {
        getInterFieldsOld = JSON.parse(jsonString);
      }
    } catch (error) {
      console.error("Error parsing JSON:", error);
    }
    const changesArrays = getInterFieldsOld.length > 0 ? getInterFieldsOld : [];
    const requestHeaderKeys = Object.keys(REQUEST_HEADER);
    const apiFieldNames = API_FIELD_NAME_SF.reduce((acc, item) => {
      acc[item.Api] = item.Label || "";
      return acc;
    }, {});

    for (const key in updated) {
      if (original[key] !== updated[key]) {
        const headerKey = requestHeaderKeys.find((fKey) => fKey.includes(key));

        if (headerKey) {
          const api = REQUEST_HEADER[headerKey];
          const label = apiFieldNames[api] || "";

          const existingFieldIndex = changesArrays.findIndex(
            (item) => item.API === api
          );

          if (existingFieldIndex !== -1) {
            changesArrays[existingFieldIndex].Value = updated[key];
          } else {
            changesArrays.push({
              Label: label,
              API: api,
              User: userInfoTest.username,
              Source: "Website",
              Value: updated[key],
            });
          }
        }
      }
    }

    return changesArrays;
  }

  const handleClickTab = (event) => {
    setActiveTab(event.currentTarget.dataset.tab);
  };

  // status ของ request item (Status = ค่าจาก Salesforce, StatusCustomer = สถานะที่แสดงให้ลูกค้า)
  const requestItem = objRegistrationForm?.RequestItems?.[0];
  const currentStatus =
    requestItem?.StatusCustomer || (location.state && location.state.status) || "";
  // สถานะที่เข้าสู่ขั้นตอน approval แล้ว ห้ามแก้ไข/ส่งซ้ำ
  const isSubmitDisabled =
    DISABLED_SUBMIT_STATUSES.includes(
      String(requestItem?.Status || "").toLowerCase()
    ) ||
    DISABLED_SUBMIT_STATUSES_CUSTOMER.includes(
      String(currentStatus).toLowerCase()
    );

  return (
    <Container maxWidth="xl" className="ReEvaluateScreen">
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={dataLoading || dataSaving}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      {/* header */}
      <div style={{ paddingLeft: 100 }}>
        <Box display="flex" justifyContent="center" width="100%">
          <label style={{ fontWeight: "bold" }}>{companyName}</label>
        </Box>
        <br />
        <Box display="flex" justifyContent="center" width="100%">
          <DescriptionIcon sx={{ color: "#C20BCC", width: 50, height: 50 }} />
        </Box>
        <br />
        <Box display="flex" justifyContent="center" width="100%">
          <label style={{ fontWeight: "bold" }}>Post On-Boarding</label>
        </Box>
        <br />
      </div>

      {/* title header */}
      <div className="header">
        <div>
          <label>Request Number</label>
          <p>{requestNumber}</p>
        </div>
        <div>
          <label>Last Update Date</label>
          <p>{lastModifiedDate}</p>
        </div>
      </div>

      {/* status-bar */}
      <div className="path">
        <ApprovalStatus currentStatus={currentStatus} />
      </div>

      {/* form-data */}
      <div style={{ display: "flex", marginTop: "10px" }}>
        {/* tab-side-left */}
        <div className="sidebar">
          <nav className="slds-nav-vertical" aria-label="Sub page">
            <div className="slds-nav-vertical__section">
              <ul aria-describedby="entity-header">
                <li
                  className={
                    activeTab === "RegistrationForm"
                      ? "slds-nav-vertical__item slds-is-active"
                      : "slds-nav-vertical__item"
                  }
                  onClick={handleClickTab}
                  data-tab="RegistrationForm"
                >
                  <span className="slds-nav-vertical__action">
                    Request Form
                  </span>
                </li>
                {/* <li
                  className={
                    activeTab === "RequiredDocuments"
                      ? "slds-nav-vertical__item slds-is-active"
                      : "slds-nav-vertical__item"
                  }
                  onClick={handleClickTab}
                  data-tab="RequiredDocuments"
                >
                  <span className="slds-nav-vertical__action">
                    Required Documents
                  </span>
                </li> */}
              </ul>
            </div>
          </nav>
        </div>

        {/* form-body */}
        {!dataLoading && (
          <div style={{ background: "white", flexGrow: 1 }}>
            <Stack sx={{ width: "100%" }} spacing={4}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  paddingBottom: 2,
                }}
              >
                {/* <Button
                  variant={isEditedForm ? "outlined" : "contained"}
                  onClick={() => setIsEditedForm((prev) => !prev)}
                  style={
                    isEditedForm ? { color: "red", borderColor: "red" } : {}
                  }
                >
                  {isEditedForm ? "View" : "Edit"}
                </Button> */}
              </Box>
              {activeTab === "RegistrationForm" && (
                <>
                  {location.state && location.state.edited ? (
                    <RegistrationForm
                      onFormDataObjectChange={(data) =>
                        setObjRegistrationForm(data)
                      }
                      formDataObject={objRegistrationForm}
                      formId={id}
                      loading={() => { }}
                    />
                  ) : (
                    <RegistrationFormView
                      onFormDataObjectChange={(data) =>
                        setObjRegistrationForm(data)
                      }
                      formDataObject={objRegistrationForm}
                      formId={id}
                      loading={() => { }}
                    />
                  )}
                </>
              )}
              {/* {activeTab === "RequiredDocuments" && (
                <RequiredDocument
                  onUploadFileOtherChange={(fileList) =>
                    setUploadFileOther(fileList)
                  }
                  onFormDataObjectChange={(data) =>
                    setObjRegistrationForm(data)
                  }
                  formDataObject={objRegistrationForm}
                  // formDataDraft={(data) => updateRequestFormByIds(data)}
                  formId={id}
                />
              )} */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Button
                  sx={{ p: 1, m: 1 }}
                  variant="outlined"
                  color="error"
                  onClick={() => {
                    Swal.fire({
                      title: "Do you want to leave this page?",
                      icon: "question",
                      position: "center",
                      showDenyButton: true,
                      showCancelButton: false,
                      confirmButtonText: "Yes",
                    }).then((result) => {
                      if (result.isConfirmed) {
                        navigate("/main");
                      }
                    });
                  }}
                >
                  Cancel
                </Button>
                <Button
                  sx={{ p: 1, m: 1 }}
                  variant="contained"
                  disabled={isSubmitDisabled}
                  onClick={() => {
                    objRegistrationForm.Documents.Others.push(
                      ...uploadFileOther
                    );
                    updateRequestFormByIds(objRegistrationForm);
                  }}
                >
                  Submit
                </Button>
              </Box>
            </Stack>
          </div>
        )}
      </div>

      <ModalRegistrationForm
        fromId={company.Id}
        request={registrationNumber}
        open={openModal}
        onHide={() => setOpenModal(false)}
      />
    </Container>
  );
}
